const getGlobalNotifications = () => {
    return new Promise((res, rej) => {
        axios.defaults.headers.common["Authorization"] = localStorage.getItem("token");
        axios.get("merchant/fetchglobalnotifications")
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const getTerminalNotifications = (request) => {
    return new Promise((res, rej) => {
        axios.post("merchant/fetchterminalnotifications", request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

const readNotification = (request) => {
    return new Promise((res, rej) => {
        axios.post("merchant/readnotification", request)
            .then((response) => {
                res(response.data);
            })
            .catch((err) => {
                rej(err);
            })
    })
};

export default {
    getGlobalNotifications,
    getTerminalNotifications,
    readNotification
};